export default __webpack_public_path__ + "static/media/vinyl.0a9ddafd.png";